import attribute from './serialize/attribute';
import deviceAttribute from './serialize/device-attribute';
import email from './serialize/email';
import event from './serialize/event';
import form from './serialize/form';
import pageview from './serialize/pageview';
import screenview from './serialize/screenview';
import action from './serialize/action';
import relationship from './serialize/relationship';
import ActionCondition from 'cio/app-models/conditions/action';
import InvalidCondition from 'cio/app-models/conditions/invalid';
import GroupCondition from 'cio/app-models/conditions/group';
import AbstractCondition from 'cio/app-models/conditions/abstract';
import { SerializedGroupCondition } from 'cio/types/conditions/condition';
import AttributeCondition from 'cio/app-models/conditions/attribute';
import DeviceAttributeCondition from 'cio/app-models/conditions/device-attribute';
import EmailCondition from 'cio/app-models/conditions/email';
import EventCondition from 'cio/app-models/conditions/event';
import FormCondition from 'cio/app-models/conditions/form';
import PageviewCondition from 'cio/app-models/conditions/pageview';
import ScreenviewCondition from 'cio/app-models/conditions/screenview';
import RelationshipCondition from 'cio/app-models/conditions/relationship';

function invalid(condition: InvalidCondition) {
  return condition.get('json');
}

export const isGroupCondition = (filters: AbstractCondition | null): filters is GroupCondition =>
  (filters as GroupCondition)?.type === 'group';

function group(obj: GroupCondition): SerializedGroupCondition {
  let { operator, children } = obj;
  let json = {
    [operator]: children.compact().map((_child) => {
      let child = _child as AbstractCondition;
      let type = (child.uiType ?? child.type) as string;

      if (type === 'group') {
        return group(child as GroupCondition);
      } else if (type === 'action') {
        return action(child as ActionCondition);
      } else if (type === 'attribute') {
        return attribute(child as AttributeCondition);
      } else if (type === 'device_attribute') {
        return deviceAttribute(child as DeviceAttributeCondition);
      } else if (type === 'email') {
        return email(child as EmailCondition);
      } else if (type === 'event') {
        return event(child as EventCondition);
      } else if (type === 'form') {
        return form(child as FormCondition);
      } else if (type === 'pageview') {
        return pageview(child as PageviewCondition);
      } else if (type === 'screenview') {
        return screenview(child as ScreenviewCondition);
      } else if (type === 'relationship') {
        return relationship(child as RelationshipCondition);
      } else if (type === 'invalid') {
        return invalid(child as unknown as InvalidCondition);
      }

      if (child instanceof ActionCondition) {
        return action(child as ActionCondition);
      }

      return {};
    }),
  };

  return json as SerializedGroupCondition;
}

export default group;
